import { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";
import { useAuthCtx } from "./useAuthCtx.ts";
import { MissingAccountScreenPath } from "./MissingAccountScreen.tsx";

export function RequireAuthOrRedirect({
  children,
  fallbackPath,
}: PropsWithChildren<{ fallbackPath: string }>) {
  const { authUser, user } = useAuthCtx();

  if (!authUser) return <Navigate to={fallbackPath} replace />;
  if (!user) return <Navigate to={MissingAccountScreenPath} replace />;

  return children ?? null;
}
